import { EventEmitter, Input, Output, Directive } from '@angular/core';

import { MobileSectorVm, OptionVm, Flight, NewFlightItemVm } from '@app/entities/flight-results';
import { getFlightKeys } from '@shared/flight-itinerary/mappers/flight-keys.mapper';

@Directive()
export abstract class FlightItineraryAbstractComponent {

  @Input() showedDetails: string[] = [];

  @Output() setShowedDetails: EventEmitter<string> = new EventEmitter<string>();

  protected toggleItineraryDetail(itineraryId: number, sector: MobileSectorVm): void {
    const flightKeys = this.getItineraryFlightKeys(itineraryId, sector);
    this.setShowedDetails.emit(flightKeys);
  }

  protected showItineraryDetail(itineraryId: number, sector: MobileSectorVm): boolean {
    return this.showedDetails.includes(getFlightKeys(itineraryId, sector));
  }

  public getItineraryFlightKeys(itineraryId: number, sector: MobileSectorVm): string {
    return getFlightKeys(itineraryId, sector);
  }

  public hasScales(sector: OptionVm | MobileSectorVm | NewFlightItemVm): boolean {
    return (sector.Flights.length - 1) > 0;
  }

  public justOneScale(sector: OptionVm | MobileSectorVm | NewFlightItemVm): boolean {
    return (sector.Flights.length - 1) === 1;
  }

  public scalesNumber(sector: OptionVm | MobileSectorVm | NewFlightItemVm): number {
    return sector ? sector.Flights.length - 1 : 0;
  }

  public scales(sector: OptionVm | MobileSectorVm | NewFlightItemVm): Flight[] {
    return sector ? [...sector.Flights.slice(0, -1)] : [];
  }

  public scalesText(sector: MobileSectorVm | NewFlightItemVm): string {
    if (this.hasScales(sector)) {
      return this.justOneScale(sector) ? 
        'FLIGHT_RESULTS_MODULE.ITINERARY_LIST_SECTION.SCALE' : 'FLIGHT_RESULTS_MODULE.ITINERARY_LIST_SECTION.SCALES';
    }
    return 'FLIGHT_RESULTS_MODULE.ITINERARY_LIST_SECTION.DIRECT_TRIP';
  }

}
